import { render, staticRenderFns } from "./BudgetModalAdSet.vue?vue&type=template&id=70681d83&scoped=true&"
import script from "./BudgetModalAdSet.vue?vue&type=script&lang=ts&"
export * from "./BudgetModalAdSet.vue?vue&type=script&lang=ts&"
import style0 from "./BudgetModalAdSet.vue?vue&type=style&index=0&id=70681d83&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70681d83",
  null
  
)

export default component.exports